export const environment = import.meta.env.VITE_APP_ENVIRONMENT || 'stage'
export const mobileBackendUrl = import.meta?.env?.VITE_BACKEND_BASE_URL || 'http://mobilebackend.stage.powerup.money'
export const testAuthToken = import.meta?.env?.VITE_TEST_AUTH_TOKEN || ''
export const devP2PAppType = import.meta.env?.VITE_DEV_P2P_APP_TYPE || 'POWER_UP'
/** CDN root for MF static assets — set via `VITE_MF_LOGO_BASE_URL` in `.env.local`. */
export const mfLogoBaseUrl = import.meta.env?.VITE_MF_LOGO_BASE_URL || 'https://cdn.powerup.money/assets'
/** CDN host (no `/assets`) — set via `VITE_MF_CDN_BASE_URL` (e.g. allowlist JSON). */
export const cdnBaseUrl = import.meta.env?.VITE_MF_CDN_BASE_URL || 'https://cdn.powerup.money'

// Faro (Grafana) RUM collector
export const faroCollectorUrl =
  import.meta.env.VITE_FARO_COLLECTOR_URL || 'https://reactwebviews.powerup.money/faro/collect'
export const faroApiKey = import.meta.env.VITE_FARO_API_KEY || ''

export const secondaryTestAuthTokenObject = import.meta?.env?.VITE_TEST_SECONDARY_AUTH_TOKEN_OBJ || ''

// Safe area overlays configuration
export const navigationBarType = import.meta?.env?.VITE_NAVIGATION_BAR_TYPE || 'gesture'
export const showSafeAreaBorders = import.meta?.env?.VITE_SHOW_SAFE_AREA_BORDERS === 'true' || false
export const hideStatusBar = import.meta?.env?.VITE_HIDE_STATUS_BAR === 'true' || false
